import {useLexicalComposerContext} from '@lexical/react/LexicalComposerContext';
import {COMMAND_PRIORITY_LOW, KEY_DOWN_COMMAND} from 'lexical';
import {useEffect} from 'react';

export const KeystrokeCountPlugin = ({onKeystroke}: {onKeystroke: () => void}) => {
  const [editor] = useLexicalComposerContext();

  useEffect(() => {
    return editor.registerCommand(
      KEY_DOWN_COMMAND,
      () => {
        onKeystroke();
        return false;
      },
      COMMAND_PRIORITY_LOW
    );
  }, [editor, onKeystroke]);

  return null;
};
